import React, { useState, KeyboardEvent } from "react";
import styles from "./styles.module.scss";
import { Spacing } from "spacing/component";
import { TextCaption } from "fonts/Caption";

import { classNames } from "helpers/string";
import showPasswordImgSrc from "../../../assets/31-visibility-m.svg";
import clearImgSrc from "../../assets/svgs/close-24px.svg";
import { IInputProps } from "./types/index";
import { LabelFont } from "../fonts";

const enterKey = 13;

export const InputFieldVW = ({
  error,
  placeholder,
  disabled,
  type,
  autoFocus,
  value = "",
  iconSrc,
  onChange,
  onClick,
  onClear,
  iconClick,
  label,
  name,
  readOnly,
  onKeyDown
}: IInputProps) => {
  const [inputType, setInputType] = useState(type);

  function handleKeyPress(event: KeyboardEvent) {
    if (event.keyCode === enterKey || event.charCode === enterKey)
      iconClick && iconClick();
  }

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <label htmlFor={name}>
          <LabelFont>{label}</LabelFont>
        </label>
        <input
          onClick={onClick}
          className={`${classNames(styles, { error })} ${iconSrc &&
            styles.hasIcon}`}
          type={inputType}
          onChange={onChange}
          onKeyPress={handleKeyPress}
          onKeyDown={onKeyDown}
          {...{
            disabled,
            value,
            placeholder,
            autoFocus,
            name,
            readOnly
          }}
        />
        {type === "password" && (
          <Spacing
            ph="s"
            pv="xs"
            className={styles.showPasswordIcon}
            onClick={() =>
              setInputType(inputType === "password" ? "text" : "password")
            }
          >
            <img src={showPasswordImgSrc} />
          </Spacing>
        )}
        {onClear && value && (
          <img
            className={styles.clearIcon}
            onClick={onClear}
            src={clearImgSrc}
          />
        )}
        {iconSrc && (
          <img className={styles.showIcon} onClick={iconClick} src={iconSrc} />
        )}
      </div>
      {error && (
        <React.Fragment>
          <Spacing pt="5xs" />
          <TextCaption className={styles.redColor}>{error}</TextCaption>
        </React.Fragment>
      )}
    </div>
  );
};
